const SUPPORTED_CHART_TYPES = {
  number: 'NUMBER',
  percent: 'PERCENT'
};

export {
  SUPPORTED_CHART_TYPES
};
